import React from 'react';

// Google Charts infers column types from the first data row, so a table that is
// only a header row ends up all-string and the chart renders a red
// "Data column(s) for axis #0 cannot be of type string" box. Show this instead
// whenever a graph has no rows to plot.
export const NoDataMessage = () => <p className="reporting__no-data-message">No data for this time period.</p>;
